<template>
  <v-app>
    <v-container class="pa-0">
      <NoteDetail :guid="noteGuid" :usn="usn" :single="single" />
    </v-container>
  </v-app>
</template>

<script>
import evernote from '@/services/EvernoteService'
import NoteDetail from '@/components/NoteDetail'

export default {
  components: { NoteDetail },
  props: {
    guid: String
  },
  created() {
    evernote.setup()
  },
  // moutend() {
  //   this.$matomo.trackPageView('note')
  // },
  computed: {
    evernote: () => evernote,
    noteGuid: vm => (vm.guid ? vm.guid : vm.$route.params.guid),
    // updated: vm =>
    //   isNaN(vm.$route.query.updated) ? 0 : Number(vm.$route.query.updated),
    usn: vm => (isNaN(vm.$route.query.usn) ? 0 : Number(vm.$route.query.usn)),
    single: vm =>
      isNaN(vm.$route.query.single) ? false : Number(vm.$route.query.single) > 0
    // oguid: vm =>
    //   isNaN(vm.$route.query.single) ? false : Number(vm.$route.query.single) > 0
  }
  //   watch: {
  //     $route(to, from) {
  //       // /note/A -> /note/B の遷移時に呼ばれる（親からの遷移では呼ばれない）
  //       console.log(to)
  //       console.log(from)
  //     }
  //   }
}
</script>

<style></style>
